import { z } from 'zod'

export const assignBenefitsGetAssignListSchema = z.object({
  /** 會員卡號 */
  memberCardNumber: z.string(),
  /** 英文姓名 */
  englishName: z.string(),
  /** 姓名 */
  name: z.string()
})

export interface AssignBenefitsGetAssignList
  extends z.infer<typeof assignBenefitsGetAssignListSchema> {}

export class AssignBenefitsGetAssignList {
  constructor() {
    return {
      memberCardNumber: '',
      englishName: '',
      name: ''
    }
  }
}
